module.exports = __webpack_public_path__ + "static/media/feed1.a0772dc5.jpg";